import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Shown for the last few minutes before an idle sign-out. AuthService owns the
 * countdown and closes this itself when activity resumes; the button is here
 * for keyboard and touch users, whose activity may not register otherwise.
 */
@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html'
})
export class SessionTimeoutDialogComponent {

  @Input() secondsLeft: number;
  @Input() totalSeconds = 60;

  constructor(private activeModal: NgbActiveModal) { }

  /** Time left as m:ss, e.g. "4:32". */
  get timeLeft(): string {
    const seconds = Math.max(0, this.secondsLeft || 0);
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  }

  /** Width of the countdown bar, as a percentage of the warning period left. */
  get progress(): number {
    return this.totalSeconds ? Math.max(0, (this.secondsLeft / this.totalSeconds) * 100) : 0;
  }

  staySignedIn() {
    this.activeModal.close(true);
  }
}
